/**
 * Date helper utilities
 */

/**
 * Format date to YYYY-MM-DD
 */
export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Format date for display (MM/DD/YYYY)
 */
export const formatDisplayDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
};

/**
 * Format date string (YYYY-MM-DD) to "Weekday, MM/DD/YYYY"
 */
export const formatDisplayDateWithDay = (dateString) => {
    // Create date object (ensure timezone doesn't shift day)
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
    const formattedDate = formatDisplayDate(date);

    return `${weekday}, ${formattedDate}`;
};

/**
 * Format datetime for display
 */
export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'America/New_York'
    });
};

/**
 * Format time for display (e.g., "10:15 AM")
 */
export const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
};

/**
 * Combine date and time into ISO datetime string
 */
export const combineDateAndTime = (date, time) => {
    const [hours, minutes] = time.split(':');
    const combined = new Date(date);
    combined.setHours(parseInt(hours), parseInt(minutes), 0, 0);

    // Format as ISO string with timezone offset
    return combined.toISOString();
};

/**
 * Get date range (start and end dates)
 */
export const getDateRange = (startDate, daysAhead) => {
    const start = new Date(startDate);
    const end = new Date(startDate);
    end.setDate(end.getDate() + daysAhead);

    return {
        startDate: formatDate(start),
        endDate: formatDate(end)
    };
};
